import React, { useEffect, useCallback, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { get } from 'lodash';

import { AppDivisionContext } from './AppDivisionContext';
import {
  useOpenFindingsData,
  useFetchAllFindingTypes,
  useTeamManagement,
  useInspectionsDueData,
  useFindingsOverviewData,
  useFetchAllFindingTypesForFO,
  useFetchProjectsListForCal,
  useInspectionsCertificationDue,
  useMyProjectsData,
  useFetchListForInspectionCert,
  useFetchListForAcknowledgementCert,
  useRegionsTabData,
  useDivisionalSpecificsData,
  useFetchAllProjectTypesForDashboardTabs,
  useFetchAllFindingTypesForCM,
  useFetchAllInspectionTypesForCM,
  useFetchAllDivisionsForCM,
  useFetchAllRegionsForCM,
  useFetchPermits
} from '../hooks/customDashboard';

interface InspectionQueryParamsIFC {
  s?: string;
}

export type DashboardConextTypeValues = {
  list: Array<any>;
  setList: (input: any) => void;
  dashboardTabIndex: any;
  setDashboardTabIndex: (input: any) => void;
  inspectionsCertDue: any;
  inspectionsCertDueQuery: any;
  inspectionsCertDueQueryParams: InspectionQueryParamsIFC;
  setinspectionsCertDueQueryParams: (input: any) => void;
  displayStatsForOF: any;
  isLoadingForOF: any;
  allProjectsForOF: any;
  findingTypeListForOF: any;
  setDisplayStatsForOF: any;
  setIsLoadingForOF: any;
  fetchStatsFuncForOF: any;
  getTeamManagementData: any;
  teamManagementData: any;
  isLoadingForTM: any;
  setIsLoadingForTM: any;
  displayStatsForID: any,
  allProjectsForID: any,
  isLoadingForID: any,
  setDisplayStatsForID: any,
  setIsLoadingForID: any,
  fetchStatsFuncForID: any,
  displayStatsForFO: any,
  allProjectsForFO: any,
  isLoadingForFO: any,
  findingTypeListForFO: any,
  setDisplayStatsForFO: any,
  setIsLoadingForFO: any,
  displayStatsForCal: any,
  isLoadingForCal: any,
  projectsListForCal: any,
  setDisplayStatsForCal: any,
  setIsLoadingForCal: any,
  dashboardWidgetSizeHolder: any,
  setDashboardWidgetSizeHolder: any,
  displayStatsForMP: any,
  allProjectsForMP: any,
  isLoadingForMP: any,
  setDisplayStatsForMP: any,
  setIsLoadingForMP: any,
  fetchStatsFuncForMP: any,
  precipitationDataForCal: any,
  setPrecipitationDataForCal: any,
  selectedCalProject: any,
  setSelectedCalProject: any,
  isLoadingForInspectionCert: any,
  projectsListForInpectionCert: any,
  setProjectsListForInpectionCert: any,
  setSearchQueryForInspectionCert: any,
  fetchFuncForInspectionCert: any,
  isLoadingForAcknowledgementCert: any,
  projectsListForAcknowledgementCert: any,
  setProjectsListForAcknowledgementCert: any,
  setSearchQueryForAcknowledgementCert: any,
  fetchFuncForAcknowledgementCert: any,
  regionsTabList: any,
  allRegionsTabList: any,
  isLoadingRegionsTab: any,
  setRegionsTabList: any,
  setIsLoadingRegionsTab: any,
  queryParamsForRegionsTab: any,
  setqueryParamsForRegionsTab: any,
  setqueryParamsForDivisionalSpecificsCM: any,
  divisionalSpecificsForCM: any,
  allDivisionalSpecificsListForCM: any,
  isLoadingDivisionalSpecificsForCM: any,
  setDivisionalSpecificsListForCM: any,
  setIsLoadingDivisionalSpecificsForCM: any,
  projectTypeListForDashboardTabs: any,
  findingTypeListForCM: any,
  inspectionTypeListForCM: any
  divisionListForCM: any,
  regionListForCM: any,
  isLoadingRegionListForCM: any,
  permitsList: any,
  setPermitsList: any,
  isLoadingForPermits: any,
  setIsLoadingForPermits: any,
  queryPermits: any,
  queryParamsForPermits: any,
  setQueryParamsForPermits: any
};

const DashboardContext = React.createContext<DashboardConextTypeValues>(
  null as any,
);

export const DashboardProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const routeMatch = useRouteMatch();
  const appDivisionContext = React.useContext(AppDivisionContext);
  const divisionId = get(
    routeMatch.params,
    'division_id',
    appDivisionContext.appDivisionId,
  );

  const [list, setList] = React.useState<any[]>([]); // setting list for dashboard widget items
  const [dashboardTabIndex, setDashboardTabIndex] = React.useState<any>(Number(localStorage.getItem('dashboardTabLastSelected')) || 0);
  const [prevList, setPrevList] = React.useState<any[]>([]);

  const [loadInspectionData, setLoadInspectionData] =
    React.useState<boolean>(false);

  const [inspectionsCertDueQueryParams, setinspectionsCertDueQueryParams] =
    React.useState<InspectionQueryParamsIFC>({});
  const inspectionsCertDueQuery = useInspectionsCertificationDue(
    inspectionsCertDueQueryParams ? inspectionsCertDueQueryParams : {},
    divisionId,
    loadInspectionData,
  );

  const inspectionsCertDue = inspectionsCertDueQuery || [];

  const [dashboardWidgetSizeHolder, setDashboardWidgetSizeHolder] = useState<any>({});

  const [displayStatsForCal, setDisplayStatsForCal] = useState<any>([]);
  const [isLoadingForCal, setIsLoadingForCal] = useState<boolean>(false);

  const [precipitationDataForCal, setPrecipitationDataForCal] = useState<any>([])
  const [selectedCalProject, setSelectedCalProject] = useState<any>()
  const [queryParamsForRegionsTab, setqueryParamsForRegionsTab] = React.useState<any>({});
  const [queryParamsForDivisionalSpecificsCM, setqueryParamsForDivisionalSpecificsCM] = React.useState<any>({});

  const [queryParamsForPermits, setQueryParamsForPermits] = React.useState<any>({s: '', p: 1, orderBy: null, orderType: null});

  const [
    displayStatsForOF,
    allProjectsForOF,
    isLoadingForOF,
    setDisplayStatsForOF,
    setIsLoadingForOF,
    fetchStatsFuncForOF,
  ] = useOpenFindingsData(list);

  const [
    getTeamManagementData,
    teamManagementData,
    isLoadingForTM,
    setIsLoadingForTM,
  ] = useTeamManagement(list);

  const [
    displayStatsForID,
    allProjectsForID,
    isLoadingForID,
    setDisplayStatsForID,
    setIsLoadingForID,
    fetchStatsFuncForID,
  ] = useInspectionsDueData(list);

  const [
    displayStatsForFO,
    allProjectsForFO,
    isLoadingForFO,
    setDisplayStatsForFO,
    setIsLoadingForFO,
  ] = useFindingsOverviewData(list);


  const [
    isLoadingForInspectionCert,
    projectsListForInpectionCert,
    setProjectsListForInpectionCert,
    setSearchQueryForInspectionCert,
    fetchFuncForInspectionCert
  ] = useFetchListForInspectionCert(list)

  const [
    isLoadingForAcknowledgementCert,
    projectsListForAcknowledgementCert,
    setProjectsListForAcknowledgementCert,
    setSearchQueryForAcknowledgementCert,
    fetchFuncForAcknowledgementCert
  ] = useFetchListForAcknowledgementCert(list)

  const [
    displayStatsForMP,
    allProjectsForMP,
    isLoadingForMP,
    setDisplayStatsForMP,
    setIsLoadingForMP,
    fetchStatsFuncForMP,
  ] = useMyProjectsData(list);

  const [
    regionsTabList,
    allRegionsTabList,
    isLoadingRegionsTab,
    setRegionsTabList,
    setIsLoadingRegionsTab
  ] = useRegionsTabData(
    queryParamsForRegionsTab ? queryParamsForRegionsTab : {},
    dashboardTabIndex
    );

  const [
    divisionalSpecificsForCM,
    allDivisionalSpecificsListForCM,
    isLoadingDivisionalSpecificsForCM,
    setDivisionalSpecificsListForCM,
    setIsLoadingDivisionalSpecificsForCM,
  ] = useDivisionalSpecificsData(
    queryParamsForDivisionalSpecificsCM ? queryParamsForDivisionalSpecificsCM : {},
    dashboardTabIndex
    );

  const [
    projectTypeListForDashboardTabs
  ] = useFetchAllProjectTypesForDashboardTabs(dashboardTabIndex)

  const [
    findingTypeListForCM
  ] = useFetchAllFindingTypesForCM(dashboardTabIndex)

  const [
    inspectionTypeListForCM
  ] = useFetchAllInspectionTypesForCM(dashboardTabIndex)

  const [
    divisionListForCM
  ] = useFetchAllDivisionsForCM(dashboardTabIndex)

  const [
    regionListForCM,
    isLoadingRegionListForCM
  ] = useFetchAllRegionsForCM()

  const [
    permitsList,
    setPermitsList,
    isLoadingForPermits,
    setIsLoadingForPermits,
    queryPermits,
  ] = useFetchPermits(list, queryParamsForPermits);

  const [findingTypeListForOF] = useFetchAllFindingTypes(list);
  const [findingTypeListForFO] = useFetchAllFindingTypesForFO(list);
  const [projectsListForCal] = useFetchProjectsListForCal(list);

  const setWidgetApiData = useCallback(() => {
    const uniqueList = list.filter((item) => prevList.indexOf(item) == -1);

    if (list.length > 0 && uniqueList.length > 0) {
      if (list.includes('Certifications Due')) {
        setLoadInspectionData(true);
      }
    }

    setPrevList(list);
  }, [list]);

  useEffect(() => {
    setWidgetApiData();
  }, [list]);

  useEffect(() => {
    setSelectedCalProject(-10)
    setPrecipitationDataForCal([])
    setDisplayStatsForCal([])
  }, [appDivisionContext.appDivisionId])

  return (
    <DashboardContext.Provider
      value={{
        // dashboard widget common methods
        list,
        setList,

        // dashboard selected tab index
        dashboardTabIndex,
        setDashboardTabIndex,

        // inspection certification due variabels
        inspectionsCertDueQuery,
        inspectionsCertDue,
        inspectionsCertDueQueryParams,
        setinspectionsCertDueQueryParams,

        isLoadingForInspectionCert, // inspection Certification
        projectsListForInpectionCert, // inspection Certification
        setProjectsListForInpectionCert, // inspection Certification
        setSearchQueryForInspectionCert, // inspection Certification
        fetchFuncForInspectionCert, // inspection Certification

        isLoadingForAcknowledgementCert, // acknowledgement Certification
        projectsListForAcknowledgementCert, // acknowledgement Certification
        setProjectsListForAcknowledgementCert, // acknowledgement Certification
        setSearchQueryForAcknowledgementCert, // acknowledgement Certification
        fetchFuncForAcknowledgementCert, // acknowledgement Certification

        // open findings
        displayStatsForOF,
        allProjectsForOF,
        isLoadingForOF,
        findingTypeListForOF,
        setDisplayStatsForOF,
        setIsLoadingForOF,
        fetchStatsFuncForOF,

        // team management
        getTeamManagementData,
        teamManagementData,
        isLoadingForTM,
        setIsLoadingForTM,

        // Inspections Due
        displayStatsForID,
        allProjectsForID,
        isLoadingForID,
        setDisplayStatsForID,
        setIsLoadingForID,
        fetchStatsFuncForID,

        // Findings Overview
        displayStatsForFO,
        allProjectsForFO,
        isLoadingForFO,
        findingTypeListForFO,
        setDisplayStatsForFO,
        setIsLoadingForFO,

        // Calendar
        displayStatsForCal,
        isLoadingForCal,
        projectsListForCal,
        setDisplayStatsForCal,
        setIsLoadingForCal,
        precipitationDataForCal,
        setPrecipitationDataForCal,
        selectedCalProject,
        setSelectedCalProject,

        //My Projects
        displayStatsForMP,
        allProjectsForMP,
        isLoadingForMP,
        setDisplayStatsForMP,
        setIsLoadingForMP,
        fetchStatsFuncForMP,

        // Dashboard Tabs
        regionsTabList,
        allRegionsTabList,
        isLoadingRegionsTab,
        setRegionsTabList,
        setIsLoadingRegionsTab,
        queryParamsForRegionsTab,
        setqueryParamsForRegionsTab,

        divisionalSpecificsForCM,
        allDivisionalSpecificsListForCM,
        isLoadingDivisionalSpecificsForCM,
        setDivisionalSpecificsListForCM,
        setIsLoadingDivisionalSpecificsForCM,
        setqueryParamsForDivisionalSpecificsCM,

        projectTypeListForDashboardTabs,
        findingTypeListForCM,
        inspectionTypeListForCM,
        divisionListForCM,
        regionListForCM,
        isLoadingRegionListForCM,

        // Permits
        permitsList,
        setPermitsList,
        isLoadingForPermits,
        setIsLoadingForPermits,
        queryPermits,
        queryParamsForPermits,
        setQueryParamsForPermits,

        // dashboard Size
        dashboardWidgetSizeHolder,
        setDashboardWidgetSizeHolder
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardContext;
